// About Us / policy page links, shared by the footer, the pages themselves and the admin editor.
import { useEffect, useState } from 'react';
import { api } from './api';

export const pageHref = (slug) => (slug === 'about' ? '/about' : `/policies/${slug}`);

export function usePageList() {
  const [list, setList] = useState([]);
  useEffect(() => { api('/api/pages').then(setList).catch(() => {}); }, []);
  return list;
}
